import { useRoute } from 'vue-router'
import useGet from '../../../core/composables/api/useGet'
import { computed, toValue, watch, type MaybeRef } from 'vue'
import type { DialogJournalSlide } from './use-prepare-journal-slide'

export const useFinalJournalSlide = (feedbackTopicId: MaybeRef<string>) => {
  const route = useRoute()

  const url = computed(() => {
    return `dialog/${route.params.id}/journal-slide/${toValue(feedbackTopicId)}`
  })

  const { data, load, status } = useGet<DialogJournalSlide>(url)

  watch(
    url,
    () => {
      load()
    },
    { immediate: true },
  )

  return { data, status }
}
